export const ID_MERCANTIL = 54;

const TIPO_PERSONA_FISICA = 1;
const TIPO_PERSONA_JURIDICA = 2;
const TIPO_USO_PARTICULAR = 1;
const TIPO_USO_COMERCIAL = 2;
const CONDICION_FISCAL_RI = 3;
const CONDICION_FISCAL_NO_ALCANZADO = 5;
const CONDICION_FISCAL_CONSUMIDOR_FINAL = 6;

export const evaluarCondicionesMercantil = (datosCotizacion) => {
   const tieneAccesoriosExtra =
      Array.isArray(datosCotizacion.accesorios) &&
      datosCotizacion.accesorios.length > 0;
   if (tieneAccesoriosExtra) {
      return {
         disponible: false,
         motivo: 'Mercantil Andina no cotiza cuando se agregan accesorios adicionales (solo GNC).',
      };
   }

   if (
      datosCotizacion.tipoPersona === TIPO_PERSONA_FISICA &&
      datosCotizacion.tipoUso === TIPO_USO_COMERCIAL
   ) {
      return {
         disponible: false,
         motivo: 'Mercantil Andina no cotiza para Persona Física con uso Comercial.',
      };
   }

   if (
      datosCotizacion.tipoPersona === TIPO_PERSONA_FISICA &&
      datosCotizacion.tipoIva !== CONDICION_FISCAL_CONSUMIDOR_FINAL
   ) {
      return {
         disponible: false,
         motivo: 'Mercantil Andina solo cotiza para Persona Física con condición fiscal Consumidor Final.',
      };
   }

   if (datosCotizacion.esCamion === true) {
      const esCamionValido =
         datosCotizacion.tipoPersona === TIPO_PERSONA_JURIDICA &&
         datosCotizacion.tipoUso === TIPO_USO_COMERCIAL &&
         datosCotizacion.tipoIva === CONDICION_FISCAL_RI;
      if (!esCamionValido) {
         return {
            disponible: false,
            motivo:
               'Para camiones, Mercantil Andina requiere: Persona Jurídica, uso Comercial y condición fiscal Responsable Inscripto.',
         };
      }
   }

   if (
      datosCotizacion.tipoPersona === TIPO_PERSONA_JURIDICA &&
      datosCotizacion.tipoUso === TIPO_USO_PARTICULAR
   ) {
      return {
         disponible: false,
         motivo: 'Mercantil Andina no cotiza para Persona Jurídica con uso Particular.',
      };
   }

   if (
      datosCotizacion.tipoPersona === TIPO_PERSONA_JURIDICA &&
      datosCotizacion.tipoIva === CONDICION_FISCAL_NO_ALCANZADO
   ) {
      return {
         disponible: false,
         motivo: 'Mercantil Andina no cotiza persona jurídica con condición fiscal No Alcanzado.',
      };
   }

   return { disponible: true, motivo: null };
};

export const evaluadorMercantil = {
   evaluarAntesDeCotizar: evaluarCondicionesMercantil,
   usaCardGris: true,
   mensajeArrayVacio:
      'Mercantil Andina no tiene cotizaciones disponibles para los datos ingresados.',
   mensajeErrorApi:
      'Mercantil Andina no tiene cotizaciones disponibles para el vehículo o los datos ingresados. Probá con otra cobertura o consultá con tu asesor comercial.',
};
